/**
 * Gets a user's display name based on priority order:
 * 1. Username
 * 2. Discord Username
 * 3. First Name + Last Name
 * 4. Fallback value
 * 5. User ID
 *
 * If no profile is specified, follows the standard priority order.
 *
 * @param {Object} user - The user object containing profile information
 * @param {Object} [options] - Additional options for the function
 * @param {string} [options.fallback] - Name to use if no display name is found
 * @param {boolean} [options.formattedDiscord=false] - If true, formats the name for results import with Discord username  (*Username* · Discord: *DiscordUsername* or *Unlinked*)
 * @returns {string|null} The display name, fallback value, or null if no valid name is found
 */
export default function getUserName(user, options = {}) {
  if (!user) return options.fallback || null

  const { fallback = null, formattedDiscord = false } = options
  let userInfo = user
  if (user.user) userInfo = { ...userInfo, ...user.user }

  // if this is a results import, prioritize driver display names with discord username
  if (formattedDiscord) {
    return `${userInfo.username} ·  Discord: ${userInfo?.discordUsername || 'Unlinked'}`
  }

  // Standard priority order if no profile display names are found
  if (userInfo.username) return userInfo.username
  if (userInfo.discordUsername) return userInfo.discordUsername
  if (userInfo.firstName && userInfo.lastName)
    return userInfo.firstName + ' ' + userInfo.lastName
  return fallback || userInfo.id
}
